export const tanstackQueryBuiltInAPI = [
  'QueryClient',
  'QueryCache',
  'MutationCache',
  'focusManager',
  'onlineManager',
  'useQuery',
  'useInfiniteQuery',
  'useMutation',
  'useIsFetching',
  'useIsMutating',
  'useMutationState',
  'useSuspenseQuery',
  'useQueryClient',
  'QueryClientProvider',
  "UseMutateFunction",
  "useQueries",
  "useSuspenseInfiniteQuery",
  "SuspenseQueriesOptions",
  "SuspenseQueriesResults",
  "useSuspenseQueries",
  "usePrefetchQuery",
  "usePrefetchInfiniteQuery",
  "HydrationBoundary",
  "HydrationBoundaryProps",
  "QueryErrorClearResetFunction",
  "QueryErrorIsResetFunction",
  "QueryErrorResetBoundary",
  "QueryErrorResetBoundaryFunction",
  "QueryErrorResetBoundaryProps",
  "QueryErrorResetFunction",
  "useQueryErrorResetBoundary",
  "QueryClientContext",
  "QueryClientProviderProps",
]
